import {
  collection,
  where,
  getFirestore,
  query,
  onSnapshot,
  setDoc,
  serverTimestamp,
  doc,
  deleteDoc,
  orderBy,
  limit,
  getDocs,
} from "firebase/firestore";
import {
  uploadString,
  getStorage,
  ref,
  uploadBytesResumable,
  getMetadata,
  getDownloadURL,
} from "firebase/storage";
import moment from "moment";
import slugify from "slugify";
import lodash from "lodash";
import { app } from "../../config/config";
import { TYPES } from "./media.type";
import { REF } from "../ref";

const storage = getStorage(app);
const firestore = getFirestore(app);

// -------------------------- Media  --------------------------
// // Theo dõi dữ liệu Media
// const mediaSub = [];
// export const snapMedia = (callback) => (dispatch) => {
//   const cRef = collection(firestore, REF.MEDIA);
//   const c1 = orderBy("createAt", "desc");
//   const c2 = limit(100);
//   const qRef = query(cRef, c1, c2);
//   const unSub = onSnapshot(qRef, (snapshot) => {
//     if (snapshot) {
//       const data = snapshot.docs.map((doc) => doc.data());
//       getMediaSuccess(dispatch, data);
//       if (callback) {
//         callback();
//       }
//     }
//   });
//   mediaSub.push(unSub);
// };

// export const snapMediaFromTo =
//   ({ from, to }, callback) =>
//   (dispatch) => {
//     const cRef = collection(firestore, REF.MEDIA);
//     const c1 = where("createAt", ">=", from);
//     const c2 = where("createAt", "<=", to);
//     const c3 = orderBy("createAt", "desc");
//     const qRef = query(cRef, c1, c2, c3);
//     const unSub = onSnapshot(qRef, (snapshot) => {
//       if (snapshot) {
//         const data = snapshot.docs.map((doc) => doc.data());
//         getMediaSuccess(dispatch, data);
//         if (callback) {
//           callback();
//         }
//       }
//     });
//     mediaSub.push(unSub);
//   };

// export const unSnapMedia = () => (dispatch) => {
//   mediaSub.forEach((subscriber) => {
//     subscriber();
//   });
//   mediaSub.length = 0;
// };

// // Theo dõi dữ liệu Media
// export const getMedias = (callback) => (dispatch) => {
//   const cRef = collection(firestore, REF.MEDIA);
//   const c1 = orderBy("createAt", "desc");
//   const c2 = limit(100);
//   const qRef = query(cRef, c1, c2);
//   getMediaSuccess(dispatch, null);
//   getDocs(qRef).then((snapshot) => {
//     if (snapshot) {
//       const data = snapshot.docs.map((doc) => doc.data());
//       getMediaSuccess(dispatch, data);
//       if (callback) {
//         callback();
//       }
//     }
//   });
// };

// export const setMonth = (month, callback) => (dispatch) => {
//   setMonthSuccess(dispatch, month);
// };

// // Theo dõi dữ liệu Media
// export const getMediaFromTo =
//   ({ from, to }, callback) =>
//   (dispatch) => {
//     const cRef = collection(firestore, REF.MEDIA);
//     const c1 = where("createAt", ">=", from);
//     const c2 = where("createAt", "<=", to);
//     const c3 = orderBy("createAt", "desc");
//     const qRef = query(cRef, c1, c2, c3);
//     getMediaSuccess(dispatch, null);
//     getDocs(qRef).then((snapshot) => {
//       if (snapshot) {
//         const data = snapshot.docs.map((doc) => doc.data());
//         getMediaSuccess(dispatch, data);
//         if (callback) {
//           callback();
//         }
//       }
//     });
//   };

// // -------------------------- Upload  --------------------------
// const inseartExt = (name, string) => {
//   return name.replace(/^([^.]*)\.(.*)$/, "$1_" + string + ".$2");
// };

// export const storageUploadMedia =
//   ({ file, thumbnail }, callback) =>
//   (dispatch) => {
//     // const year = moment().format("YYYY");
//     // const month = moment().format("MM");
//     const unix = moment().unix();
//     const slug = slugify(file?.name?.replace(/đ/gi, "d"), { lower: true });
//     const fileName = `${slug}_${unix}`;
//     const type = file?.type;
//     const path = `${REF.MEDIA}/logo/${fileName}.png`;
//     const sRef = ref(storage, path);
//     const uploadTask = uploadBytesResumable(sRef, file);
//     uploadTask.on(
//       "state_changed",
//       (snapshot) => {
//         const progress =
//           (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
//         if (callback) {
//           callback({
//             status: 201,
//             data: progress,
//           });
//         }
//       },
//       (error) => {
//         if (callback) {
//           callback({
//             status: 500,
//             data: error.message,
//           });
//         }
//       },
//       () => {
//         const media = { fileName, path, type, thumbnail };
//         addMedia({ media }).then((response) => {
//           if (callback) {
//             callback(response);
//           }
//         });
//       }
//     );
//   };

// // -------------------------- Add  --------------------------

// export const addMedia = ({ media }) => {
//   const cRef = collection(firestore, REF.MEDIA);
//   const id = doc(cRef).id;
//   const dRef = doc(cRef, id);
//   const data = {
//     ...media,
//     id,
//     createAt: serverTimestamp(),
//   };
//   return setDoc(dRef, data, { merge: true })
//     .then(() => {
//       return {
//         status: 200,
//       };
//     })
//     .catch((error) => {
//       return {
//         status: 500,
//         data: error.message,
//       };
//     });
// };

// // -------------------------- Delete  --------------------------

// export const deleteMedia =
//   ({ media }, callback) =>
//   (dispatch) => {
//     const cRef = collection(firestore, REF.MEDIA);
//     const id = media.id;
//     const dRef = doc(cRef, id);
//     deleteDoc(dRef)
//       .then(() => {
//         if (callback) {
//           callback({
//             status: 200,
//           });
//         }
//       })
//       .catch((error) => {
//         if (callback) {
//           callback({
//             status: 500,
//             data: error.message,
//           });
//         }
//       });
//   };

// -------------------------- metadata  --------------------------

export const getImageMetaData =
  ({ media }, callback) =>
  (dispatch) => {
    getMediaMetaSuccess(dispatch, null);
    getResizeMetaSuccess(dispatch, null);
    const path = media.path;
    const resizePath = media.resizePath;
    const sRef = ref(storage, path);
    const rRef = ref(storage, resizePath);
    getMetadata(sRef)
      .then((metadata) => {
        console.log({ metadata });
        getMediaMetaSuccess(dispatch, metadata);
        if (callback) {
          callback();
        }
      })
      .catch((error) => {});
    getMetadata(rRef)
      .then((metadata) => {
        getResizeMetaSuccess(dispatch, metadata);
        if (callback) {
          callback();
        }
      })
      .catch((error) => {});
  };

export const getVideoMetadata =
  ({ media }, callback) =>
  (dispatch) => {
    const path = media.path;
    const vRef = ref(storage, path);
    getMediaMetaSuccess(dispatch, null);
    getVideoUrlSuccess(dispatch, null);
    getMetadata(vRef)
      .then((metadata) => {
        console.log({ metadata });
        getMediaMetaSuccess(dispatch, metadata);
        if (callback) {
          callback();
        }
      })
      .catch((error) => {});
    getDownloadURL(vRef).then((value) => {
      getVideoUrlSuccess(dispatch, value);
    });
  };

export const getMediaByIds =
  ({ ids }, callback) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.MEDIA);
    let result = [];
    const allPromise = lodash.chunk(ids, 10)?.map((item, index) => {
      const c1 = where("id", "in", item);
      const qRef = query(cRef, c1);
      return getDocs(qRef).then((snapshot) => {
        if (snapshot) {
          const data = snapshot.docs.map((doc) => doc.data()) || [];
          const sorted = lodash.sortBy(data, (x) => {
            return lodash.indexOf(item, x.ids);
          });
          result.push(...sorted);
        }
      });
    });
    Promise.all(allPromise).then(() => {
      if (callback) {
        callback(result);
      }
    });
  };

// -------------------------- Dispatch  --------------------------
const getMediaSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.GET_MEDIA_SUCCESS,
    payload: data,
  });
};

const getMediaMetaSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.GET_MEDIA_METADATA_SUCCESS,
    payload: data,
  });
};

const getResizeMetaSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.GET_RESIZE_METADATA_SUCCESS,
    payload: data,
  });
};

const getVideoUrlSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.GET_VIDEO_SUCCESS,
    payload: data,
  });
};

const setMonthSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_MONTH_SUCCESS,
    payload: data,
  });
};

// ------------- Upload the single iamge ------------------
export const storageUploadImage =
  ({ file }, callback) =>
  (dispatch) => {
    // const year = moment().format("YYYY");
    // const month = moment().format("MM");
    const unix = moment().unix();
    const slug = slugify(file?.name?.replace(/đ/gi, "d"), { lower: true });
    const fileName = `${slug}_${unix}`;
    const type = file?.type;
    const path = `${REF.MEDIA}/logo/${fileName}.png`;
    const sRef = ref(storage, path);
    const uploadImage = uploadBytesResumable(sRef, file);
    //   uploadImage.on(
    //     "state_changed",
    //     (snapshot) => {
    //       console.log("trigger");
    //       if (snapshot) {
    //         getDownloadURL(snapshot.ref).then((response) => {
    //           console.log({ response });
    //           if (callback) {
    //             callback({
    //               status: 200,
    //               data: response,
    //             });
    //           }
    //         });
    //       }
    //     },
    //     (error) => {
    //       if (callback) {
    //         callback({
    //           status: 500,
    //           data: error.message,
    //         });
    //       }
    //     }
    //   );
    uploadImage.then(
      // "state_changed",
      (snapshot) => {
        // console.log("trigger");
        // console.log({snapshot})
        if (snapshot) {
          getDownloadURL(snapshot.ref).then((response) => {
            console.log({ response });
            if (callback) {
              callback({
                status: 200,
                data: response,
              });
            }
          });
        }
      },
      (error) => {
        if (callback) {
          callback({
            status: 500,
            data: error.message,
          });
        }
      }
    );
  };

// get the donwload url from storage
export const getUrlfromPath = () => (dispatch) => {
  const path = `media/banner/backgroundblur_680x680.png`;
  const refStorage = ref(storage, path);
  getDownloadURL(refStorage).then((url) => {
    console.log({ url });
  });
};

// upload base 64 string
export const uploadImagebase64 =
  ({ url }, callback) =>
  (dispatch) => {
    const unix = moment().unix();
    const path = `${REF.MEDIA}/logo/pic_${unix}.png`;
    const sRef = ref(storage, path);
    console.log({ path });
    // uploadString(sRef, url, "data_url").then(
    //   (snapshot) => {
    //     if (snapshot) {
    //       getDownloadURL(snapshot.ref).then((response) => {
    //         console.log({ response });
    //         if (callback) {
    //           callback({
    //             status: 200,
    //             data: response,
    //           });
    //         }
    //       });
    //     }
    //   },
    //   (error) => {
    //     if (callback) {
    //       callback({
    //         status: 500,
    //         data: error.message,
    //       });
    //     }
    //   }
    // );
  };

// -------- upload evidence --------

export const storageUploadEvidenceImage =
  ({ file }, callback) =>
  (dispatch) => {
    const unix = moment().unix();
    const slug = slugify(file?.name?.replace(/đ/gi, "d"), { lower: true });
    // const fileName = `${slug}_${unix}`;
    const fileName = `${unix}_${file?.name}`;
    const type = file?.type;
    // console.log({file});
    const path = `${REF.MEDIA}/evidences/${fileName}`;
    const sRef = ref(storage, path);
    const uploadImage = uploadBytesResumable(sRef, file);
    uploadImage.then(
      // "state_changed",
      (snapshot) => {
        // console.log("trigger");
        // console.log({snapshot})
        if (snapshot) {
          getDownloadURL(snapshot.ref).then((response) => {
            console.log({ response });
            if (callback) {
              callback({
                status: 200,
                data: response,
              });
            }
          });
        }
      },
      (error) => {
        if (callback) {
          callback({
            status: 500,
            data: error.message,
          });
        }
      }
    );
  };


  
// ------------- snap all media by branch & date -------
let mediaSub = [];
export const snapMediaByBranchByDate =
  ({ date, branch }, callback) =>
  (dispatch) => {
    snapMediaByBranchByDateSuccess(dispatch, null);
    const cRef = collection(firestore, "media");
    const c0 = where("branch", "==", branch);
    const c1 = where("date", "==", date);
    const qRef = query(cRef, c0, c1);
    let unsub = onSnapshot(qRef, (snapshot) => {
      if (snapshot) {
        const data = snapshot.docs.map((doc) => doc.data());
        snapMediaByBranchByDateSuccess(dispatch, data);
        if (callback) {
          callback();
        }
      } else (
        console.log("empty snapshot")
      )
    });
    mediaSub.push(unsub);
  };

export const unSnapMedia = () => (dispatch) => {
  mediaSub.forEach((subscriber) => {
    subscriber();
  });
  mediaSub.length = 0;
};

// dispatch
const snapMediaByBranchByDateSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.GET_MEDIA_BY_BRANCH_BY_DATE_SUCCESS,
    payload: data,
  });
};

// ------------- create media -------
export const createMedia =
  ({ data }, callback) =>
  (dispatch) => {
    if (data) {
      console.log(data)
      const cRef = collection(firestore, "media");
      const id = doc(cRef).id;
      const dRef = doc(cRef, id);
      let created = {
        ...data,
        id: id,
        createAt: serverTimestamp(),
      };
      setDoc(dRef, created, { merge: true })
        .then(() => {
          if (callback) {
            callback({
              status: 200,
            });
          }
        })
        .catch((err) => {
          if (callback) {
            callback({
              status: 500,
              data: err?.message || "Please try again!",
            });
          }
        });
    }
  };

// --------- delete Media ---------
export const deleteMedia =
  ({ mediaId }, callback) =>
  (dispatch) => {
    if (mediaId) {
      const cRef = collection(firestore, "media");
      const id = mediaId;
      const dRef = doc(cRef, id);
      deleteDoc(dRef)
        .then(() => {
          if (callback) {
            callback({
              status: 200,
            });
          }
        })
        .catch((err) => {
          if (callback) {
            callback({
              status: 500,
              data: err?.message || "Please try again!",
            });
          }
        });
    }
  };
